<template>
  <div class="input-inside-chat-label">
    <span v-if="text" class="input-label">{{ text }}</span>
    <div class="radio-group" :class="{ error: validate.$invalid && validate.$dirty }">
      <t-radio v-model="model" :name="name" :native-value="true" @input="handleChange">{{
        $t('base.yes')
      }}</t-radio>
      <t-radio v-model="model" :name="name" :native-value="false" @input="handleChange">{{
        $t('base.no')
      }}</t-radio>
    </div>
  </div>
</template>

<script>
import TRadio from 'javascript/Common/TRadio'

export default {
  name: 'ChatYesNo',
  components: { TRadio },
  props: {
    text: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    value: {
      type: [Boolean, null],
      default: null
    },
    validate: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    handleChange() {
      this.validate.$touch()
    }
  }
}
</script>
